require('./updateClientContactTimeStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { formatText } = require('core/i18n').i18n;

//@components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const InputTime = require('components/commons/contactCenter/inputTime/inputTime');

//@constants
const { WIZARD_FIRST_STEP } = require('constants/index');

class UpdateClientContactTimeStep1 extends React.Component {

    constructor(props) {
        super(props);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleBlur() {
        const { validateUIStep } = this.props;
        validateUIStep( WIZARD_FIRST_STEP );
    }

    render(){
        const {
            immStep,
            setToTime,
            setFromTime,
            step1Values,
            fromHourText,
            toHourText
        } = this.props;
        const {fromHourValue, toHourValue, title, firstMessage} = step1Values;
        const currentHoursTitle = formatText("updateClientContactTimeStep1-currentHoursTitle");
        const newHoursTitle = formatText("updateClientContactTimeStep1-newHoursTitle");

        return (
            <div className="update-client-contact-time-step1 no-print-out">
                <h4 className="wizard-step--vertical__title">{title}</h4>
                <div className="update-client-contact-time-step1__content">
                    <BlockInfo extraClass="update-client-contact-time-step1__block-info">
                        {firstMessage}
                    </BlockInfo>
                    <div className="row no-outside-gutter">
                        <div className="col-md-6">
                            <div className="update-client-contact-time-step1__current-hours">
                                <h4 className="update-client-contact-time-step1__hours-title">
                                    {currentHoursTitle}
                                </h4>
                                <div className="update-client-contact-time-step1__column">
                                    <h5>{fromHourText}</h5>
                                    <p className="update-client-contact-time-step1__current-hour">{fromHourValue}</p>
                                </div>
                                <div className="update-client-contact-time-step1__column">
                                    <h5>{toHourText}</h5>
                                    <p className="update-client-contact-time-step1__current-hour">{toHourValue}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row no-outside-gutter">
                        <div className="col-md-6">
                            <div className="update-client-contact-time-step1__new-hours">
                                <h4 className="update-client-contact-time-step1__hours-title">
                                    {newHoursTitle}
                                </h4>
                                <div className="update-client-contact-time-step1__column">
                                    <InputTime
                                        id="id_from-time"
                                        setTime={setFromTime}
                                        label={fromHourText}
                                        className="update-client-contact-time-step1__input-time"
                                        onBlur={this.handleBlur}
                                    />
                                </div>
                                <div className="update-client-contact-time-step1__column">
                                    <InputTime
                                        id="id_to-time"
                                        setTime={setToTime}
                                        label={toHourText}
                                        className="update-client-contact-time-step1__input-time"
                                        onBlur={this.handleBlur}
                                    />
                                </div>
                                <p className="update-client-contact-time-step1__error-message">
                                    {immStep.get('error')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

UpdateClientContactTimeStep1.propTypes = {
    step1Values: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    fromHourText: PropTypes.string.isRequired,
    toHourText: PropTypes.string.isRequired,
    setFromTime: PropTypes.func.isRequired,
    setToTime: PropTypes.func.isRequired,
    validateUIStep: PropTypes.func.isRequired
};

module.exports = UpdateClientContactTimeStep1;
